import Vue from 'vue';
import Router from 'vue-router';

import { pageNotFound } from './shared/components/error-pages';
import { homeRoutes } from './home';
import { bookingRoutes } from './booking';
import { helpRoutes } from './help';
import { clubRoutes } from './club';
import { packageRoutes } from './package';
import { accountRoutes } from './account';
import { spaRoutes } from './spa';
import { diningRoutes } from './dining';
import { ecommerceRoutes } from './ecommerce';
import { buddyRoutes } from './buddy';
import { checkoutRoutes } from './checkout';
import { errorRoutes } from './error';
import { virtusRoutes } from './virtus';
import { nodeEnv } from '@/environment/environment';
import services from '@/app/shared/services';
import { runIOSCookieWarmup } from '@/app/shared/services/iosCookieSyncService';
// eslint-disable-next-line import/no-cycle
import { store } from '@/app/shared/stores/store';

Vue.use(Router);

const appRoutes = [
  {
    path: '*',
    name: 'pageNotFound',
    component: pageNotFound,
    meta: {
      noLayout: false,
      title: '404 - Page not found',
    },
  },
];

const routes = [...accountRoutes, ...appRoutes, ...bookingRoutes, ...clubRoutes, ...packageRoutes, ...checkoutRoutes, ...buddyRoutes, ...helpRoutes, ...errorRoutes, ...spaRoutes, ...ecommerceRoutes, ...diningRoutes, ...homeRoutes, ...virtusRoutes];

const router = new Router({
  mode: nodeEnv === 'cordova' ? '' : 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

const isIOSCordova = process.env.VUE_APP_ENV === 'cordova'
  && process.env.VUE_APP_CORDOVA_PLATFORM === 'ios';

// authentication check
router.beforeEach(async (to, from, next) => {
  if (to.meta.title !== undefined) {
    document.title = to.meta.title;
  }

  if (to.matched.some(record => record.meta.noLayout)) {
    store.commit('toggleLayout', false);
  } else {
    store.commit('toggleLayout', true);
  }

  if (to.matched.some(record => record.meta.squeezePage)) {
    store.commit('toggleSqueezePage', true);
  } else {
    store.commit('toggleSqueezePage', false);
  }

  if (to.matched.some(record => record.meta.hideHomeClub)) {
    store.commit('toggleHideHomeClub', true);
  } else {
    store.commit('toggleHideHomeClub', false);
  }

  if (to.matched.some(record => record.meta.overrideStyle)) {
    store.commit('setOverrideStyle', true);
  } else {
    store.commit('setOverrideStyle', false);
  }

  if (store.state.user.isAdmin && to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.user.username === 'tee.time@thegrove.co.uk') {
      window.location.href = 'https://api.xviii.golf/';
      window.location = 'https://api.xviii.golf/';
    }
  }

  const needsIOSAuthValidation = isIOSCordova
    && to.matched.some(record => record.meta.requiresAuth)
    && store.state.user.isAuthenticated
    && store.state.user.username === '';

  if (needsIOSAuthValidation) {
    try {
      await runIOSCookieWarmup({ attempts: 3, delayMs: 200, deviceReadyTimeoutMs: 1000 });
      const authed = await services.account.cookieAuthenticated();
      if (!authed) {
        store.commit('toggleHideGlobalLoader', true);
        store.dispatch('setAuth', false);
      }
    } catch (err) {
      store.commit('toggleHideGlobalLoader', true);
      store.dispatch('setAuth', false);
    }
  }

  // todo: yuck, fix
  if (store.state.user.isAuthenticated) {
    store.commit('toggleHideGlobalLoader', false);
    return next(); // continue
  } if (to.matched.some(record => record.meta.requiresAuth)) {
    store.commit('toggleHideGlobalLoader', true);
    store.dispatch('setAuth', false);

    if (from.name === 'login'
      || from.name === 'loginForClub'
      || from.name === 'loginBad') {
      return next(false);
    }
    const returnUrl = `returnUrl=${window.location.pathname}${window.location.search}`;
    const loginPath = `/login/${store.state.user.homeClubName}/${store.state.user.homeClubId}`;
    return next(`${loginPath}?${returnUrl}`);
  }
  store.commit('toggleHideGlobalLoader', true);
  return next(); // not authed, no authentication needed
});

export default router;
